import React from 'react';
import { Tabs } from 'antd';
import DefaultDrawer from '../defaultDrawer/DefaultDrawer';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';
import useTranslation from '../../../../hooks/translation/useTranslation';

function PasswordRecoveryDrawer({
  activeStep,
  items,
  show,
  handleClose,
}) {
  const { trans } = useTranslation();
  const { width } = useWindowDimensions();
  return (
    <DefaultDrawer
      title={activeStep === 1 && (
        <div className="flex justify-between items-center pr-5">
          <h1 className="m-0 text-2xl">{trans('password_recovery')}</h1>
        </div>
      )}
      placement="bottom"
      setShow={handleClose}
      show={show && width < 1024}
      className="gray-after auth-drawer media"
      style={{
        backgroundColor: '#f1f2f6',
      }}
    >
      <Tabs className="register-tabs" items={items} activeKey={activeStep} />
    </DefaultDrawer>
  );
}

export default PasswordRecoveryDrawer;
